import _ from 'lodash';

import { Swarm } from '@lbs/swarm-client';

import { ResponseCodeEnum } from '@common/constants/enums/responseCode';

export const swarmRequest = async (request, command = 'get') => {
  // await new Promise((resolve) => setTimeout(resolve, 2000));

  try {
    const response = await Swarm.getInstance().getData(request, command);
    if (response.data.code === ResponseCodeEnum.Ok) return response.data.data;
    throw response.data;
  } catch (reason) {
    if (reason.code === ResponseCodeEnum.NeedToLogin) {
      return reason.data;
    }
  }
};

const getStringFromQueryObject = queryParams => {
  const searchParams = new URLSearchParams("");

  Object.entries(queryParams).forEach(([key, value]) => {
    if (!_.isNil(value)) searchParams.append(key, value);
  });

  return searchParams.toString();
};

export const checkFetchStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  throw error;
};

export const fetchRequest = async (baseUrl, apiPath = '', requestType = "GET", request = {}, timeout ) => {
  const { headers, body, queryParams, dynamicContentType, blobResponse, ...rest } = request;
  let url = `${baseUrl}${apiPath ? `/${apiPath}` : ''}`;

  if (queryParams) {
    const queryString = getStringFromQueryObject(queryParams);
    url += `?${queryString}`;
  }

  const hasTimeout = typeof timeout === 'number' && timeout > 0;
  const controller = hasTimeout ? new AbortController() : null;
  const timeoutId = hasTimeout ? setTimeout(() => controller.abort(), timeout * 1000) : null;

  try {
    const result = await fetch(url, {
      ...rest,
      method: requestType,
      headers: dynamicContentType ? (headers || {}) : {
        ...(headers || {}),
        'Content-Type': 'application/json',
      },
      body: body ? JSON.stringify(body) : null,
      ...(controller ? { signal: controller.signal } : {}),
    });

    const response = checkFetchStatus(result);

    return blobResponse ? response.blob() : response.json();
  } catch (error) {
    if (error && error.name === 'AbortError') {
      const timeoutError = new Error('Request timeout');
      // @ts-ignore augmenting error with code
      timeoutError.code = 'ETIMEDOUT';
      throw timeoutError;
    }
    throw error;
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
  }
};
